// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1ompu","signatureButtonsRight":"ModalSign_signatureButtonsRight__1h5wA"};